import { render, staticRenderFns } from "./BoletinesView.vue?vue&type=template&id=50279e38"
import script from "./BoletinesView.vue?vue&type=script&lang=ts"
export * from "./BoletinesView.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports